import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <>
      <SEO
        title="Siden blev ikke fundet (404) | Fastlane ApS"
        description="Den side, du leder efter, kunne desværre ikke findes. Gå til forsiden eller find relevante transportydelser."
      />

      <div className="min-h-[70vh] flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8 bg-slate-50">
        <div className="max-w-lg w-full text-center space-y-6 bg-white p-8 sm:p-12 rounded-3xl border border-slate-200 shadow-sm">
          <div className="w-16 h-16 rounded-full bg-red-100 text-[#c52828] flex items-center justify-center mx-auto text-2xl font-bold">
            <i className="fa-solid fa-triangle-exclamation" aria-hidden="true" />
          </div>

          <h1 className="text-4xl sm:text-5xl font-black text-[#0f2b48]">404</h1>
          <h2 className="text-xl sm:text-2xl font-bold text-slate-800">
            Siden kunne ikke findes
          </h2>
          <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
            Vi beklager, men den side du leder efter, findes ikke eller er blevet flyttet i forbindelse med opdateringen af vores hjemmeside.
          </p>

          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 rounded-lg bg-[#0f2b48] hover:bg-slate-900 text-white font-semibold text-sm transition-colors"
            >
              <i className="fa-solid fa-house mr-2 text-xs" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-800 font-semibold text-sm transition-colors border border-slate-200"
            >
              <i className="fa-solid fa-envelope mr-2 text-xs" aria-hidden="true" />
              <span>Kontakt os</span>
            </Link>
          </div>

          <div className="pt-6 border-t border-slate-100 text-left">
            <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3">Relevante hovedområder:</p>
            <div className="grid grid-cols-2 gap-2 text-xs font-semibold text-sky-800">
              <Link to="/godstransport-i-europa" className="hover:underline flex items-center gap-1.5 p-1.5 rounded-sm hover:bg-slate-50">
                <i className="fa-solid fa-angle-right text-[10px]" aria-hidden="true" />
                <span>Vejtransport</span>
              </Link>
              <Link to="/lager" className="hover:underline flex items-center gap-1.5 p-1.5 rounded-sm hover:bg-slate-50">
                <i className="fa-solid fa-angle-right text-[10px]" aria-hidden="true" />
                <span>Lagerhotel Esbjerg</span>
              </Link>
              <Link to="/containerfragt-soefragt" className="hover:underline flex items-center gap-1.5 p-1.5 rounded-sm hover:bg-slate-50">
                <i className="fa-solid fa-angle-right text-[10px]" aria-hidden="true" />
                <span>Søfragt / Container</span>
              </Link>
              <Link to="/fragtrater" className="hover:underline flex items-center gap-1.5 p-1.5 rounded-sm hover:bg-slate-50 text-amber-700">
                <i className="fa-solid fa-angle-right text-[10px]" aria-hidden="true" />
                <span>Fragtpriser / Tilbud</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
